import { Element } from "../Element.mjs";
import { isNonZeroInteger, isObject } from "../validation/index.mjs";
export var MentionNode;

(function (MentionNode) {
  MentionNode.TYPE = 'mention';

  function isMentionNode(value) {
    return Element.isElement(value, MentionNode.TYPE);
  }

  MentionNode.isMentionNode = isMentionNode;

  function validateMentionNode(value) {
    var isValid = isMentionNode(value) && isObject(value.user) && isNonZeroInteger(value.user.id);
    return isValid ? value : null;
  }

  MentionNode.validateMentionNode = validateMentionNode;
})(MentionNode || (MentionNode = {}));